// extracted by mini-css-extract-plugin
export default {"container":"SyncFromCrmConfirmationDialog_container__DEgSS","text":"SyncFromCrmConfirmationDialog_text__fHu+B"};